<template>
  <section class="related-information">
    <h4>
      <TextHeading semi margin>Related Information</TextHeading>
    </h4>
    <div class="related-information__select">
      <FormSelect semi small/>
    </div>
  </section>
</template>

<script>
import TextHeading from '../elements/TextHeading.vue'
import FormSelect from '../elements/FormSelect.vue'
export default {
  name: 'RelatedInformation',
  components: { FormSelect, TextHeading }
}
</script>

<style lang="postcss">
.related-information {
  @apply mb-16;
}
.related-information__select {
  @apply bg-primary-light px-6 py-8;
}
@screen md {
  .related-information__select {
    @apply bg-primary-light p-12;
  }
}
</style>
